import Image from './image';
export * from './image';
export default Image;